import React, {useMemo, useState} from 'react';
import {createAutocomplete} from "@algolia/autocomplete-core";
import {CloseIcon, SearchIcon} from "@chakra-ui/icons";
import drillcut_star from "../image/drillcut_star.svg";

const AutoCompleteCustom = (props) => {
    const [autocompleteState, setAutocompleteState] = useState({
        collections: [], completion: null, context: {}, isOpen: false, query: '', activeItemId: null, status: 'idle',
    });

    const autocomplete = useMemo(() => {
        return createAutocomplete({
            onStateChange({state}) {
                setAutocompleteState(state);
                // console.log("Testing state changed", state);
                // if (!state.isOpen && state.query !== undefined && state.query.length > 3) {
                //     setTimeout(() => {
                //         setAutocompleteState(state)
                //     }, 300);
                // } else {
                //     setAutocompleteState(state);
                // }
            }, ...props
        })
    }, [props]);

    const inputRef = React.useRef(null);
    const formRef = React.useRef(null);
    const panelRef = React.useRef(null);
    const {getEnvironmentProps} = autocomplete;

    React.useEffect(() => {
        if (!formRef.current || !panelRef.current || !inputRef.current) {
            return undefined;
        }

        const {onTouchStart, onTouchMove} = getEnvironmentProps({
            formElement: formRef.current, inputElement: inputRef.current, panelElement: panelRef.current,
        });

        window.addEventListener('touchstart', onTouchStart);
        window.addEventListener('touchmove', onTouchMove);

        return () => {
            window.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, [getEnvironmentProps, formRef, inputRef, panelRef]);

    function capitalize(allwords){
        return allwords.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
    }



    return (
        <div className="ais-SearchBox searchBox_searchPage" {...autocomplete.getRootProps({})}>
            {/* Visible label for accessibility */}
            <label id="autocomplete-label" htmlFor="autocomplete-input" style={{position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden'}}>Search products</label>
            <form
                ref={formRef}
                className="ais-SearchBox-form"
                {...autocomplete.getFormProps({inputElement: inputRef.current})}
            >
                <input
                    id="autocomplete-input"
                    className="ais-SearchBox-input"
                    ref={inputRef}
                    {...autocomplete.getInputProps({inputElement: inputRef.current})}
                />
                <button className="ais-SearchBox-submit" type="submit" title="Submit">
                    <SearchIcon/>
                </button>
                <button className="ais-SearchBox-reset" title="Clear" type="reset">
                    <CloseIcon/>
                </button>
            </form>

            {autocompleteState.isOpen && (
                <div
                    ref={panelRef}
                    className={[
                        'aa-Panel',
                        'aa-Panel--desktop',
                        autocompleteState.status === 'stalled' && 'aa-Panel--stalled',
                    ]
                        .filter(Boolean)
                        .join(' ')}
                    style={{ width: '100%' }}
                    {...autocomplete.getPanelProps({})}>
                    <div className="aa-PanelLayout aa-Panel--scrollable">
                        {autocompleteState.collections.map((collection, index) => {
                            const { source, items } = collection;
                            return (<section key={`source-${index}`} className="aa-Source">
                                    {items.length > 0 && (
                                        <ul className="aa-List">
                                            {items.map((item) => {
                                                return (
                                                    <li
                                                        key={item.objectID}
                                                        className="aa-Item"
                                                        {...autocomplete.getItemProps({ item, source})}>
                                                        <div className="aa-ItemWrapper">
                                                            <div className="aa-ItemContent">
                                                                <div className="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
                                                                    <img
                                                                        loading="lazy"
                                                                        src={item.image ? item.image : drillcut_star}
                                                                        alt={item.name}
                                                                        width="40"
                                                                        height="40"
                                                                    />
                                                                </div>
                                                                <div className="aa-ItemContentBody">
                                                                    {/*<Highlight hit={item} attribute="title" />*/}
                                                                    {item.title ? item.title : capitalize(autocompleteState.query)}
                                                                </div>
                                                            </div>
                                                            <div className="aa-ItemActions">
                                                                <button
                                                                    className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                                                                    type="button"
                                                                    title="Select"
                                                                    style={{ pointerEvents: 'none' }}
                                                                >
                                                                    <svg fill="currentColor" viewBox="0 0 24 24">
                                                                        <path d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                            {index > 0  && index===1? (
                                                <li className="aa-Item">
                                                    Press the search button or Enter for more results
                                                </li>) : ''}
                                        </ul>
                                    )}
                                </section>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AutoCompleteCustom;
